import { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Button, DatePicker, Form, Input, Pagination, Select, Spin } from 'antd'
import dayjs from 'dayjs'
import useStore from '@/hooks/useStore'
import FacilityResult from '@/components/Content/SearchPart/FacilityResult'
import './index.less'

const { Search } = Input
function SearchPart() {
  // const select4_Options = [{ value: '최신순', label: '최신순' }]
  const select4_Options = [
    { value: 'REGDT', label: '최신순' },
    { value: 'FCLTNM', label: '가나다순' },
  ]
  // eslint-disable-next-line n/prefer-global/process
  const isDev = process.env.NODE_ENV === 'development'
  const [form] = Form.useForm()
  const dateFormat = 'YYYY-MM-DD'
  const uiStore = useStore('uiStore')
  const mapStore = useStore('mapStore')
  const facilityStore = useStore('facilityStore')
  const [datePickerDisabled, setDatePickerDisabled] = useState(true)
  const [dateSelect, setDateSelect] = useState(false)
  const [isFromUrlId, setIsFromUrlId] = useState('')

  const [current, setCurrent] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [total, setTotal] = useState(0)

  const [orderType, setOrderType] = useState(select4_Options[0].value)
  const [isOrderTypeChanged, setIsOrderTypeChanged] = useState(false)

  useEffect(() => {
    const url = window.location.href
    const paramsObj: any = {}
    if (url) {
      const params = url.includes('?') && url.split('?')[1]
      if (params) {
        const paramsArr = params.split('&')
        paramsArr.forEach((item) => {
          const key = item.split('=')[0]
          const value = item.split('=')[1]
          paramsObj[key] = value
        })
      }
    }
    if (paramsObj.idlFcltUnqNo && mapStore.viewer) {
      setIsFromUrlId(paramsObj.idlFcltUnqNo)
      const id = localStorage.getItem('JSESSIONID') || ''
      const params2 = {
        sggCd: '',
        idlFcltPrueSeCdIn: '',
        minAr: '',
        maxAr: '',
        minUseAprvYmd: '',
        maxUseAprvYmd: '',
        searchKeyword: '',
        pageIndex: 1,
        sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
        dodCd: '',
        orderType,
      }
      facilityStore.searchFacility(params2)
    }
  }, [mapStore.viewer])

  // 최신순, 가나다순 데이터 정렬
  useEffect(() => {
    const id = localStorage.getItem('JSESSIONID') || ''
    if (orderType && isOrderTypeChanged) {
      const formValues = form.getFieldsValue()
      const searchParams = {
        sggCd: formValues.sggCd,
        idlFcltPrueSeCdIn: formValues.idlFcltPrueSeCdIn,
        minAr: formValues.minAr,
        maxAr: formValues.maxAr,
        minUseAprvYmd: dateSelect ? formValues.minUseAprvYmd.format('YYYYMMDD') : formValues.minUseAprvYmd,
        maxUseAprvYmd: dateSelect ? formValues.maxUseAprvYmd.format('YYYYMMDD') : formValues.maxUseAprvYmd,
        searchKeyword: formValues.searchKeyword,
        pageIndex: 1,
        sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
        dodCd: formValues.dodCd,
        orderType,
      }
      facilityStore.searchFacility(searchParams)
    }
    else {
      setIsOrderTypeChanged(true)
    }
  }, [orderType])

  useEffect(() => {
    setTotal(facilityStore.FacilityResultsCount)
  }, [facilityStore.FacilityResultsCount])

  const select1_Options = [
    { value: '', label: '시군구' },
    // { value: '35011', label: '전주시 완산구' },
    // { value: '35012', label: '전주시 덕진구' },
    { value: '35010', label: '전주시' },
    { value: '35020', label: '군산시' },
    { value: '35030', label: '익산시' },
    { value: '35040', label: '정읍시' },
    { value: '35050', label: '남원시' },
    { value: '35060', label: '김제시' },
    { value: '35510', label: '완주군' },
    { value: '35520', label: '진안군' },
    { value: '35530', label: '무주군' },
    { value: '35540', label: '장수군' },
    { value: '35550', label: '임실군' },
    { value: '35560', label: '순창군' },
    { value: '35570', label: '고창군' },
    { value: '35580', label: '부안군' },
  ]

  const select2_Options = [
    { value: '', label: '전체' },
    { value: 'STRUP', label: '창업' },
    { value: 'CLUR', label: '문화예술' },
    { value: 'WOKAT', label: '워케이션' },
    { value: 'ETC', label: '기타' },
  ]

  const select3_Options = [
    { value: '모든 날짜', label: '모든 날짜' },
    { value: '지난 1년', label: '지난 1년' },
    { value: '지난 3년', label: '지난 3년' },
    { value: '지난 5년', label: '지난 5년' },
    { value: '지난 10년', label: '지난 10년' },
    { value: '기간설정', label: '기간설정' },
  ]

  const select5_Options = [
    { value: '', label: '모델 전체' },
    { value: 'LOD3', label: 'LOD3' },
    { value: 'LOD4', label: 'LOD4' },
    { value: 'LODX', label: '모델 없음' },
  ]

  const searchPartHide = () => {
    uiStore.searchPartHide()
  }

  const facilityLeaseHide = () => {
    const hasImgSrc = facilityStore.FacilityLeaseCardInfo !== null && facilityStore.FacilityLeaseCardInfo.some(item => item.imgSrc)
    if (hasImgSrc) {
      facilityStore.facilityLeaseHide()
    }
  }

  const facilityInfoHide = () => {
    if (facilityStore.FacilityInfoObj !== null && 'flrNo' in facilityStore.FacilityInfoObj) {
      facilityStore.facilityInfoHide()
    }
    else if (facilityStore.FacilityLeaseInfo !== null && 'sggCd' in facilityStore.FacilityLeaseInfo) {
      facilityStore.closeCurrentPage()
    }
  }

  const facilityResultsClean = () => {
    facilityStore.facilityResultsClean(mapStore.viewer ? mapStore.viewer : window.cviewer)
    mapStore.initCamera()
    form.setFieldsValue({
      sggCd: '',
      idlFcltPrueSeCdIn: '',
      minAr: '',
      maxAr: '',
      searchKeyword: '',
      minUseAprvYmd: '',
      maxUseAprvYmd: '',
      pageIndex: 1,
      selectDate: '모든 날짜',
      dodCd: '',
      orderType,
    })
    setDatePickerDisabled(true)
    setDateSelect(false)

    // 이전에 존재하는 poi icon 초기화
    if (window.cviewer.entities) {
      window.cviewer.entities.values.forEach((entity: any) => {
        if (window.cviewer.entities.values) {
          window.cviewer.entities.remove(entity)
        }
      })
    }
  }

  const onFinish = (values: any) => {
    const id = localStorage.getItem('JSESSIONID') || ''
    const params = {
      sggCd: values.sggCd,
      idlFcltPrueSeCdIn: values.idlFcltPrueSeCdIn,
      minAr: values.minAr,
      maxAr: values.maxAr,
      minUseAprvYmd: dateSelect ? values.minUseAprvYmd.format('YYYYMMDD') : values.minUseAprvYmd,
      maxUseAprvYmd: dateSelect ? values.maxUseAprvYmd.format('YYYYMMDD') : values.maxUseAprvYmd,
      searchKeyword: values.searchKeyword,
      pageIndex: 1,
      sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
      dodCd: values.dodCd,
      orderType,
    }
    setCurrent(1)
    facilityStore.searchFacility(params)
  }

  const onSearch = (value: string) => {
    const formValue = form.getFieldsValue()
    const id = localStorage.getItem('JSESSIONID') || ''
    const params = {
      sggCd: formValue.sggCd,
      idlFcltPrueSeCdIn: formValue.idlFcltPrueSeCdIn,
      minAr: formValue.minAr,
      maxAr: formValue.maxAr,
      minUseAprvYmd: dateSelect ? formValue.minUseAprvYmd.format('YYYYMMDD') : formValue.minUseAprvYmd,
      maxUseAprvYmd: dateSelect ? formValue.maxUseAprvYmd.format('YYYYMMDD') : formValue.maxUseAprvYmd,
      searchKeyword: value,
      pageIndex: 1,
      sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
      dodCd: formValue.dodCd,
      orderType,
    }
    setCurrent(1)
    facilityStore.searchFacility(params)
  }

  const commonOnChange = (page: number) => {
    const formValue = form.getFieldsValue()
    const id = localStorage.getItem('JSESSIONID') || ''
    const params = {
      sggCd: formValue.sggCd,
      idlFcltPrueSeCdIn: formValue.idlFcltPrueSeCdIn,
      minAr: formValue.minAr,
      maxAr: formValue.maxAr,
      minUseAprvYmd: dateSelect ? formValue.minUseAprvYmd.format('YYYYMMDD') : formValue.minUseAprvYmd,
      maxUseAprvYmd: dateSelect ? formValue.maxUseAprvYmd.format('YYYYMMDD') : formValue.maxUseAprvYmd,
      searchKeyword: formValue.searchKeyword,
      pageIndex: page,
      sessionId: isDev ? `${window.SystemConfig.facilitySessionId}` : id,
      dodCd: formValue.dodCd,
      orderType,
    }
    facilityStore.searchFacility(params)
  }

  const onChange = (page: number, pageSize: number) => {
    setCurrent(page)
    commonOnChange(page)
  }

  const select3OnChange = (value: any) => {
    switch (value) {
      case '모든 날짜':
        setDatePickerDisabled(true)
        setDateSelect(false)
        form.setFieldsValue({
          minUseAprvYmd: '',
          maxUseAprvYmd: '',
        })
        break
      case '지난 1년':
        setDatePickerDisabled(false)
        setDateSelect(true)
        form.setFieldsValue({
          minUseAprvYmd: dayjs().subtract(1, 'year'),
          maxUseAprvYmd: dayjs(),
        })
        break
      case '지난 3년':
        setDatePickerDisabled(false)
        setDateSelect(true)
        form.setFieldsValue({
          minUseAprvYmd: dayjs().subtract(3, 'year'),
          maxUseAprvYmd: dayjs(),
        })
        break
      case '지난 5년':
        setDatePickerDisabled(false)
        setDateSelect(true)
        form.setFieldsValue({
          minUseAprvYmd: dayjs().subtract(5, 'year'),
          maxUseAprvYmd: dayjs(),
        })
        break
      case '지난 10년':
        setDatePickerDisabled(false)
        setDateSelect(true)
        form.setFieldsValue({
          minUseAprvYmd: dayjs().subtract(10, 'year'),
          maxUseAprvYmd: dayjs(),
        })
        break
      case '기간설정':
        setDatePickerDisabled(false)
        setDateSelect(true)
        form.setFieldsValue({
          minUseAprvYmd: dayjs(),
          maxUseAprvYmd: dayjs(),
        })
        break
    }
  }

  return (
    <div className={'SearchPart'}>
      <div style={{ width: '100%' }}>
        <div className={'info-inner'}>
          <div className={'facility-info'}>
            <Form form={form} onFinish={onFinish}>
              <Form.Item name={'sggCd'} style={{ marginBottom: 10 }} initialValue={select1_Options[0].value}>
                <Select className={'SearchPart-Select'} options={select1_Options} />
              </Form.Item>
              <Form.Item name={'idlFcltPrueSeCdIn'} style={{ marginBottom: 10 }} initialValue={select2_Options[0].value}>
                <Select className={'SearchPart-Select'} options={select2_Options} />
              </Form.Item>

              <Form.Item name={'dodCd'} style={{ marginBottom: 10 }} initialValue={select5_Options[0].value}>
                <Select className={'SearchPart-Select'} options={select5_Options} />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Form.Item
                  name={'minAr'}
                  className={'SearchPart-ItemGroup'}
                  initialValue={''}
                  rules={[
                    {
                      required: false,
                      pattern: /^[0-9]\d*$/g,
                      message: '번호를 입력해 주세요',
                    },
                  ]}
                >
                  <Input className={'SearchPart-Input'} placeholder="0" suffix="m²" />
                </Form.Item>
                <div className={'SearchPart-ItemGroup-Icon'}>~</div>
                <Form.Item
                  name={'maxAr'}
                  className={'SearchPart-ItemGroup'}
                  initialValue={''}
                  rules={[
                    {
                      required: false,
                      pattern: /^[0-9]\d*$/g,
                      message: '번호를 입력해 주세요',
                    },
                  ]}
                >
                  <Input className={'SearchPart-Input'} placeholder="최대" suffix="m²" />
                </Form.Item>
              </Form.Item>
              <Form.Item name={'selectDate'} initialValue={select3_Options[0].value} style={{ marginBottom: 10 }}>
                <Select className={'SearchPart-Select'} options={select3_Options} onChange={select3OnChange} />
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Form.Item className={'SearchPart-ItemGroup'} name={'minUseAprvYmd'} initialValue={''}>
                  <DatePicker disabled={datePickerDisabled} className={'SearchPart-DataPicker'} format={dateFormat} style={{ width: '100%' }} />
                </Form.Item>
                <div className={'SearchPart-ItemGroup-Icon'}>~</div>
                <Form.Item className={'SearchPart-ItemGroup'} name={'maxUseAprvYmd'} initialValue={''}>
                  <DatePicker disabled={datePickerDisabled} className={'SearchPart-DataPicker'} format={dateFormat} style={{ width: '100%' }} />
                </Form.Item>
              </Form.Item>
              <Form.Item initialValue={''} name={'searchKeyword'} style={{ marginBottom: 10 }}>
                <Search className={'SearchPart-Search'} placeholder="검색어를 입력해주세요" onSearch={onSearch} />
              </Form.Item>
              <Form.Item style={{ marginBottom: 10 }}>
                <Button className={'SearchPart-Button-Reset'} onClick={facilityResultsClean}>
                  <span translate="no">초기화</span>
                </Button>
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button htmlType="submit" className={'SearchPart-Button-Default'}>
                  검색
                </Button>
              </Form.Item>
            </Form>
          </div>
          <div className={'list-inner'}>
            <Spin tip="검색..." size="large" spinning={facilityStore.SearchLoding}>
              <div className={'top-box'}>
                <div>
                  <span translate="no">검색결과</span>
                  <strong translate="no">{facilityStore.FacilityResultsCount}건</strong>
                </div>
                <Select className={'Search-Results-Select'} bordered={false} options={select4_Options}
                  // defaultValue={select4_Options[0].value}
                  value={orderType}
                  onChange={(value: any) => {
                    setOrderType(value)
                  }}
                />
              </div>
              {facilityStore.SearchResultShow
                ? (
                  <>
                    <FacilityResult isFromUrlId={isFromUrlId} />
                    <div style={{ textAlign: 'center', margin: 10 }}>
                      <Pagination showSizeChanger={false} onChange={onChange} current={current} pageSize={pageSize} total={total} />
                    </div>
                  </>
                  )
                : (
                  <div className={'not-info'}>
                    <span translate="no">해당지역에는</span>
                    <br />
                    <span translate="no">유휴시설이 없습니다.</span>
                  </div>
                  )}
            </Spin>
          </div>
        </div>
      </div>
      {/* <div className={'HideButton'}>
        <button className={'btn-fold'} onClick={searchPartHide} />
      </div> */}

      {uiStore.SearchPartShow === true
        ? <div className={'HideButton'}>
          <button className={'btn-fold'} onClick={searchPartHide} />
        </div>
        : <div className={'HideButton'}>
          <button className={'btn-open'} onClick={searchPartHide} />
        </div>}

      {facilityStore.FacilityLeaseShow === true
        ? <div></div>
        : <div className={'FacilityLease-ShowButton'}>
          <button className={'btn-open'} onClick={facilityLeaseHide} />
        </div>}

      {facilityStore.isOpendTabsPage === true
        ? (
          <div>
          </div>
          )
        : (
          // isOpendTabsPage가 false인 경우
            facilityStore.FacilityInfoShow === true
              ? (
              <div>
              </div>
                )
              : (
              // FacilityInfoShow가 false인 경우
              <div className={'HideButton2'}>
                <button className={'btn-open'} onClick={facilityInfoHide} />
              </div>
                )
          )
      }
    </div>
  )
}

export default observer(SearchPart)
